import { render } from "./HelpDeskCard.vue?vue&type=template&id=0f020bbb&scoped=true"
import script from "./HelpDeskCard.vue?vue&type=script&lang=js"
export * from "./HelpDeskCard.vue?vue&type=script&lang=js"

import "./HelpDeskCard.vue?vue&type=style&index=0&id=0f020bbb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f020bbb"]])

export default __exports__